'use client';
import { ComponentProps } from 'react';
import { Typography } from '@bgzt/ui';
import clsx from 'clsx';
import Image from 'next/image';

import styles from './HomeShortCutItem.module.css';

type Props = {
  label: string;
  imageUrl: ComponentProps<typeof Image>['src'];
  webUrl: string;
  onClick?(): void; // LogClick 의 onClick 이 작동하려면 prop 이 선언되어있어야합니당. 지우지마셔용
};
export const HomeShortCutItem = ({ label, imageUrl, webUrl, onClick }: Props) => {
  const isCategoryType = webUrl.includes('/category');

  return (
    <div className={styles.container}>
      <span className={clsx([styles.image, !isCategoryType && styles.brandType])} role="link" onClick={onClick}>
        <Image src={imageUrl} alt={`${label} 아이콘`} priority placeholder="empty" width={52} height={52} unoptimized />
      </span>
      <Typography variant="L12" color="gray-700" className={styles.title}>
        {label}
      </Typography>
    </div>
  );
};
